import { ProductLibraryDetail, ProductLibraryItem, ProductLibraryMinPremium } from "./types";
import React, { ReactNode, createContext, useContext, useState } from "react";
import { emdash, notImplemented } from "../../services/Library";

import { AuthContext } from "../../components/AuthContextProvider";
import { DropdownItemProps } from "semantic-ui-react";
import { Role } from "../../types";
import { useParams } from "react-router-dom";

interface ProductLibraryContextProps {
    selectedProductLibraryItem: ProductLibraryItem | undefined;
    setSelectedProductLibraryItem: (data: ProductLibraryItem | undefined) => void;
    selectedProductDetailItem: ProductLibraryDetail | undefined;
    setSelectedProductDetailItem: (data: ProductLibraryDetail | undefined) => void;
    selectedMinPremiumItem: ProductLibraryMinPremium | undefined;
    setSelectedMinPremiumItem: (data: ProductLibraryMinPremium | undefined) => void;
    productDetail: ProductLibraryDetail[];
    minPremiumData: ProductLibraryMinPremium[];
    setProductLibraryID: React.Dispatch<React.SetStateAction<number | undefined>>;
    ProductLibraryID: number | undefined;
    productLibraryID?: string | undefined;
    isAdmin: boolean;
    disableEdit?: boolean;
    analystOptions: DropdownItemProps[];
    setAnalystOptions: (options: DropdownItemProps[]) => void;
}

export const ProductLibraryContext = createContext<ProductLibraryContextProps>({
    selectedProductLibraryItem: {} as ProductLibraryItem,
    setSelectedProductLibraryItem: notImplemented,
    selectedProductDetailItem: {} as ProductLibraryDetail,
    setSelectedProductDetailItem: notImplemented,
    selectedMinPremiumItem: {} as ProductLibraryMinPremium,
    setSelectedMinPremiumItem: notImplemented,
    productDetail: [],
    minPremiumData: [],
    setProductLibraryID: notImplemented,
    productLibraryID: undefined,
    ProductLibraryID: 0,
    isAdmin: false,
    disableEdit: false,
    setAnalystOptions: notImplemented,
    analystOptions: []
});

export const getDisplayText = (value: number | null, options: DropdownItemProps[]) => {
    const text = options?.find((x) => x.value === value);
    return text?.text || emdash;
};

export const getValue = (type: string, options: DropdownItemProps[]) => {
    const option = options?.find((x) => x.text === type);
    return option?.value || 0;
};

const ProductLibraryContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { productLibraryID } = useParams<{ productLibraryID: string }>();
    const [ProductLibraryID, setProductLibraryID] = useState<number | undefined>(+(productLibraryID as string));
    const [selectedProductDetailItem, setSelectedProductDetailItem] = useState<ProductLibraryDetail>();
    const [selectedMinPremiumItem, setSelectedMinPremiumItem] = useState<ProductLibraryMinPremium>();
    const [selectedProductLibraryItem, setSelectedProductLibraryItem] = useState<ProductLibraryItem>();
    const productDetail = selectedProductLibraryItem?.DetailData as ProductLibraryDetail[];
    const minPremiumData = selectedProductLibraryItem?.MinPremiumData as ProductLibraryMinPremium[];
    const [analystOptions, setAnalystOptions] = useState<DropdownItemProps[]>([]);
    const { userHasRole } = useContext(AuthContext);

    const isAdmin = userHasRole(Role.ServicingAdmin);
    const disableEdit = !isAdmin && selectedProductLibraryItem?.IsQcComplete;

    return (
        <ProductLibraryContext.Provider
            value={{
                selectedProductLibraryItem,
                setSelectedProductLibraryItem,
                selectedProductDetailItem,
                setSelectedProductDetailItem,
                selectedMinPremiumItem,
                setSelectedMinPremiumItem,
                productDetail,
                minPremiumData,
                setProductLibraryID,
                ProductLibraryID,
                isAdmin,
                disableEdit,
                setAnalystOptions,
                analystOptions
            }}
        >
            {children}
        </ProductLibraryContext.Provider>
    );
};

export default ProductLibraryContextProvider;
